<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" title="Create Ticket">
      <v-card flat class="px-2">
        <form autocomplete="off" @submit.prevent="onSubmit">
          <v-row>
            <v-col cols="12" md="2" lg="2">
              <v-autocomplete
                key="id"
                :items="zones"
                v-model="selectedZones"
                item-text="name"
                hide-details
                return-object
                clearable
                @change="getFranchiseeList()"
                dense
                outlined
                required
                :disabled="isFranchiseeUser"
              >
                <template v-slot:label>
                  Select Zone <span class="red--text">*</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="2" lg="2">
              <v-autocomplete
                :items="franchiseeArr"
                v-model="franchiseeID"
                item-text="companyName"
                item-value="id"
                hide-details
                :disabled="readonlyflag || isFranchiseeUser"
                dense
                outlined
                required
              >
                <template v-slot:label>
                  Select Franchisee <span class="red--text">*</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3">
              <v-autocomplete
                @change="getQueryTypeList()"
                :items="queryRelatedToInfo"
                v-model="queryRelatedToId"
                item-text="label"
                item-value="id"
                hide-details
                :disabled="readonlyflag"
                required
                dense
                outlined
              >
                <template v-slot:label>
                  Query Related To <span class="red--text">*</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3">
              <v-autocomplete
                :items="queryType"
                v-model="querytypeId"
                item-text="label"
                item-value="id"
                hide-details
                :disabled="readonlyflag"
                required
                dense
                outlined
                @change="setqueryTypeStringInSubject()"
              >
                <template v-slot:label>
                  Query Type <span class="red--text">*</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="2" lg="2">
              <v-autocomplete
                :items="priority"
                v-model="priorityID"
                item-text="name"
                item-value="id"
                hide-details
                :disabled="readonlyflag"
                required
                dense
                outlined
              >
                <template v-slot:label>
                  Priority <span class="red--text">*</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                placeholder="Add subject line for new ticket."
                v-model.trim="subject"
                :disabled="readonlyflag"
                outlined
                required
                dense
                hide-details
                :prefix="subjectPrefix"
              >
                <template v-slot:label>
                  Subject <span class="error--text">*</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="12" lg="12">
              <v-textarea
                outlined
                :disabled="readonlyflag"
                v-model="description"
                placeholder="Description should be maxmimum of 500 character."
                counter="500"
                maxlength="500"
                required
                dense
              >
                <template v-slot:label>
                  Description <span class="error--text">*</span>
                </template>
              </v-textarea>
            </v-col>
            <!-- <v-col cols="12" md="3" lg="3">
              <v-menu
                v-model="showTicketEndDateMenuDialog"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    hide-details
                    dense
                    outlined
                    v-model="ticketEndDate"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                    <template v-slot:label>
                      Ticket End Date <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="ticketEndDate"
                  :min="ticketMinDate"
                  @input="showTicketEndDateMenuDialog = false"
                ></v-date-picker>
              </v-menu>
            </v-col> -->
            <v-col cols="12" md="6" lg="6">
              <v-file-input
                dense
                outlined
                v-model="dropFiles"
                multiple
                append-icon="mdi-paperclip"
                @click:clear="resetDropFilesArray"
                persistent-hint
                accept=".pdf, image/*, video/*"
                hint="File Size Should be less than or equal to 50MB"
              >
                <template v-slot:label>
                  Upload File
                </template>
                <template v-slot:selection="{ text, index }">
                  <v-chip
                    small
                    label
                    close
                    color="primary"
                    @click:close="deleteDropFile(index)"
                  >
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" md="8">
              <v-progress-circular v-if="isProgressBarVisible" :rotate="360" :size="100" :width="15"
                :value="Number(uploadPercentage)" color="success">
                {{ Number(uploadPercentage) }}
              </v-progress-circular>
            </v-col>
            <v-col cols="12" md="4">
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" type="submit">
                  <v-icon left> mdi-plus </v-icon>
                  Create
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card>
    </material-card>
  </v-container>
</template>

<script>
// import moment from 'moment'
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
import stores from '../../stores'
export default {
  name: 'CreateTicket',
  components: {
    MaterialCard
  },
  data () {
    return {
      sizeInMB: '',
      flag: '',
      category: '',
      dropFiles: [],
      ActivityID: '',
      queryRelatedToInfo: [],
      queryType: [],
      priority: [],
      franchiseeID: null,
      franchiseeArr: [],
      subject: '',
      subjectPrefix: '',
      subjectPrefixArray: [],
      priorityID: '',
      description: '',
      querytypeId: '',
      queryRelatedToId: '',
      readonlyflag: false,
      isLoading: false,
      loadingComponent: null,
      zones: [],
      selectedZones: null,
      ticketEndDate: null,
      showTicketEndDateMenuDialog: false,
      ticketMinDate: null,
      fileExtension: ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'tif', 'webp', 'mp4', 'avi', 'mkv', 'mov', 'wmv', 'flv'],
      isFranchiseeUser: false
    }
  },
  computed: {
    ...mapState([
      'isDisableUpload',
      'isProgressBarVisible',
      'uploadPercentage'
    ]),
    ...mapGetters({
      isDisableUpload: 'isDisableUpload',
      uploadPercentage: 'uploadPercentage',
      isProgressBarVisible: 'isProgressBarVisible',

      updateVisibilityStatus: 'updateVisibilityStatus'
    })
  },
  async created () {
    this.isFranchiseeUser = stores.user.me.isFranchiseeUser
    let currentDate = new Date()
    currentDate.setHours(currentDate.getHours() + 48)
    this.ticketEndDate = currentDate.toISOString().split('T')[0]
    // this.ticketMinDate = currentDate.toISOString().split('T')[0]
    await this.getZoneDetails()
    if (this.isFranchiseeUser && this.zones.length > 0) {
      this.selectedZones = this.zones[0]
      if (this.selectedZones) {
        await this.getFranchiseeList()
        this.franchiseeID = this.franchiseeArr[0].id
      }
    }
    await this.getQueryRelatedList()
  },
  watch: {
    dropFiles: {
      handler: function (newVal) {
        this.onFilechange()
      },
      deep: true
    }
  },
  methods: {
    getQueryTypeList: async function () {
      try {
        this.subjectPrefixArray = []
        if (this.queryRelatedToId) {
          let queryRelatedToSelected = this.queryRelatedToInfo.filter(item => { return item.id === this.queryRelatedToId })
          this.subjectPrefixArray[0] = queryRelatedToSelected[0].label
        }
        this.subjectPrefix = this.subjectPrefixArray.join(' > ')
        this.isLoading = true
        let payload = {}
        payload.projectmoduleid = parseInt(this.queryRelatedToId)
        const res = await http.post(`${constants.API_URL}/api/sbTicketing/getQueryTypeList`, payload)
        if (res.status === 200) {
          if (res.data.status) {
            this.queryType = res.data.data
          } else {
            return this.$dialog.error({
              title: 'Error',
              text: res.data.msg
            })
          }
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    setqueryTypeStringInSubject: function () {
      if (this.querytypeId) {
        let selectQueryType = this.queryType.filter((item) => { return item.id === this.querytypeId })
        this.subjectPrefixArray[1] = selectQueryType[0].label
      }
      this.subjectPrefix = this.subjectPrefixArray.join(' > ')
    },
    getQueryRelatedList: async function () {
      try {
        let payload = {}
        this.isLoading = true
        let res = await http.post(`${constants.API_URL}/api/sbTicketing/getQueryRelatedToList`, payload)
        if (res.status === 200) {
          this.queryRelatedToInfo = res.data.QueryRelatedTo.data
          this.priority = res.data.priorityList
          this.priority.forEach(item => {
            if (item.name === 'Moderate') {
              item.name = 'Medium'
            }
          })
          let temp = this.priority[1]
          this.priority[1] = this.priority[2]
          this.priority[2] = temp
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        console.log('error in fetching User : ', errorMessage)
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        let zone = []
        zone.push(this.selectedZones.name)
        if (zone.length > 0) {
          const response = await http.post(
            `${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`,
            {
              zone: zone
            }
          )
          let data = response.data
          this.franchiseeArr = _.map(data, (e) => {
            if (e.id) {
              if (e.id.toString().length === 1) {
                e.companyName = `${'(00' + e.id + ')'} ` + e.companyName
              } else if (e.id.toString().length === 2) {
                e.companyName = `${'(0' + e.id + ')'} ` + e.companyName
              } else {
                e.companyName = `${'(' + e.id + ')'} ` + e.companyName
              }
              e.companyName = e.region
                ? e.companyName + `${' (' + e.region + ')'}`
                : e.companyName
            }
            return e
          })
        } else {
          this.franchiseeArr = []
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    onFilechange: function () {
      if (this.dropFiles.length > 0) {
        // Validate Formate Of File
        let fileExtensionValidation = false
        this.dropFiles.forEach(item => {
          let splitNameOndot = item.name.split('.')
          let ext = splitNameOndot[1]
          if (this.fileExtension.indexOf(ext.toLowerCase()) === -1) {
            if (!fileExtensionValidation) {
              fileExtensionValidation = true
            }
          }
        })
        if (fileExtensionValidation) {
          this.errMsg('Please upload valid file to create ticket.')
          this.dropFiles = []
          return false
        }
        // Validate File Size
        let fileSize = null
        this.dropFiles.filter((s) => {
          fileSize = s.size
          return s.size
        })

        let Sizes = 0
        for (let file of this.dropFiles) {
          Sizes = Sizes + file.size
        }

        let totalSize = (Sizes / (1024 * 1024)).toFixed(2)

        this.sizeInMB = (fileSize / (1024 * 1024)).toFixed(2)

        if (this.sizeInMB && totalSize > 50) {
          this.$dialog.error({
            title: 'Error',
            text: 'File limit exceeded. Please try again with file size under 50MB'
          })
          this.dropFiles = []
        }
      }
    },
    onSubmit: async function () {
      if (this.franchiseeID) {
        this.$buefy.dialog.confirm({
          message: 'Do you want to create ticket?',
          onConfirm: async () => {
            let formData = new FormData()
            formData.append('franchiseeID', parseInt(this.franchiseeID))
            let franchiseeName = ''
            if (this.franchiseeID) {
              _.map(this.franchiseeArr, (item) => {
                if (item.id === this.franchiseeID) {
                  franchiseeName = item.companyName
                }
              })
            }
            formData.append('franchiseeName', franchiseeName)
            formData.append('subject', this.subjectPrefix + ' - ' + this.subject)
            formData.append('description', this.description)
            formData.append('queryRelatedToID', this.queryRelatedToId)
            formData.append('queryTypeID', this.querytypeId)
            formData.append('priorityID', this.priorityID)
            _.map(this.priority, (item) => {
              if (item.id === this.priorityID) {
                this.priorityName = item.name
              }
            })
            formData.append('priority', this.priorityName)
            if (this.dropFiles.length > 0) {
              this.dropFiles.forEach(file => {
                formData.append('file', file)
              })
            }
            if (this.selectedZones) {
              formData.append('zone', this.selectedZones.name)
            }
            if (this.ticketEndDate) {
              formData.append('endDate', this.ticketEndDate)
            }
            try {
              const res = await http.post(
                `${constants.API_URL}/api/sbTicketing/createTicket`,
                formData
              )
              if (res.status === 200 && res.data.status) {
                this.$dialog.info({
                  text: 'Ticket created successfully. <br /> Our team will be with you shortly.',
                  title: 'Success'
                })
                this.$router.push({
                  name: 'beesTicketList',
                  params: { ticketstatus: 'open' }
                })
              } else {
                return this.$dialog.error({
                  text: res.data.msg,
                  title: 'Error'
                })
              }
            } catch (e) {
              const errorMessage =
                (e && e.response && e.response.data.message) || e.message
              return this.$dialog.error({
                text: errorMessage,
                title: 'Error'
              })
            }
          }
        })
      } else {
        return this.$dialog.error({
          title: 'Error',
          text: 'Please select franchisee based on zone!'
        })
      }
    },
    deleteDropFile (index) {
      this.dropFiles.splice(index, 1)
    },
    resetDropFilesArray: function () {
      this.dropFiles = []
    },
    changeAssignee: function (value) {
      if (value === this.queryId) {
        _.map(this.queryRelated, (item) => {
          if (item && item.id === this.queryId) {
            this.category = this.queryId
            this.queryName = item.name
            this.deptId = item.deptId
          }
        })
      }
      if (value === this.queryTypeId) {
        _.map(this.queryType, (item) => {
          if (item.id === this.queryTypeId) {
            this.queryTypeName = item.name
          }
        })
      }
      if (value === this.priorityId) {
        _.map(this.priority, (item) => {
          if (item.id === this.priorityId) {
            this.priorityName = item.name
          }
        })
      }
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-zones`
        )

        this.zones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style>
#chiptxt2 {
  display: inline-block;
  width: 180px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
</style>
